import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function App() {
  useLenis();
  return (
    <div className="App">
      <div className="grain-overlay" />
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
